import Section from './_Section'
import RatesCalloutWrapper from '../helpers/RatesCalloutWrapper'
import { transformPaddingToTailwind } from '../../helpers/style'

function RatesCalloutCard(props) {
  const componentPadding = transformPaddingToTailwind(props.componentPadding)
  const alignment = props.contentAlignment?.toLowerCase() || 'left'
  const textAlignClass = alignment === 'center' ? 'text-center' : alignment === 'right' ? 'text-right' : 'text-left'

  return (
    <Section type="ratesCalloutCard" outerClass={componentPadding} sectionTitle={false} innerClass="px-6" {...props}>
      <RatesCalloutWrapper {...props} contentAlignment={textAlignClass} />
    </Section>
  )
}

export default RatesCalloutCard
